import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

export interface IB2RFundingWarningModalParameters {
    isOpen: boolean;
    continueCallback(): void;
    cancelCallback(): void;
}

export const B2RFundingWarningModal = ({
    isOpen,
    continueCallback,
    cancelCallback,
}: IB2RFundingWarningModalParameters): React.ReactElement => {
    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='b2r-funding-warning-title'
                aria-describedby='b2r-funding-warning-description'
                title='B2R Funding Over 95%'
                maxWidth='sm'
            >
                <div
                    className='page-header'
                    role='banner'
                >
                    <h1 id='b2r-funding-warning-title'>B2R Funding Over 95%</h1>
                </div>
                <DialogContent>
                    <DialogContentText id='b2r-funding-warning-description'>
                        The draw you are finalizing will fund this project over 95%. Please confirm this is correct with the POC
                        before proceeding.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button
                        id='b2rFundingWarningContinueButton'
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button primary'
                        onClick={continueCallback}
                    >
                        Continue
                    </button>
                    <button
                        id='b2rFundingWarningCancelButton'
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button hollow'
                        onClick={cancelCallback}
                    >
                        Cancel
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
